import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Header } from 'src/app/shared/components/header/header.model';
import { PODDataService } from 'src/app/core/poddata.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registration-form-print',
  templateUrl: './registration-form-print.component.html',
  styleUrls: ['./registration-form-print.component.scss']
})

export class RegistrationFormPrintComponent implements OnInit {
  headerData: Header = new Header();
  activePrint: string = null;
  labelCaption: any;
  formId: number;
  userId :any;
  printHeader = true;
  @Output() emitPrint: EventEmitter<any>;
  @Input('appendixA-data') set _appendixA(val) {

   
  }
  constructor(private poddataService: PODDataService, private router: Router) {
    this.emitPrint = new EventEmitter<any>();
    this.getCompanyName()

    if (this.formId == 1) {
        this.activePrint = "PrintFormVal"
    }
    else if (this.formId == 2) {
        this.activePrint = "PrintFormCourt"
    }
    else {
        this.activePrint = "PrintFormJud"
    }
  }
  ngOnInit(): void {
    this.labelCaption = 'Registration';
    this.headerData.className = 'registraion-guideline';
    this.headerData.isSubHeader = true;
    this.headerData.headTwo = this.labelCaption;
    this.userId = sessionStorage.getItem('userId');
    if (this.userId) {
      this.headerData.isHeaderRight = true;
    }
  }
  getCompanyName(): void {
    this.poddataService.getCompanyItems().forEach(companyName => {
      this.formId = companyName[2];
    });
  }
  printPage() {
    let printObj = {
      print: "print",
      activeForm: "RegistrationPrint"
    }
    this.emitPrint.emit(printObj);
  }
  redirectToHome() {
    let userId = sessionStorage.getItem('userId');
    if (userId) {
      this.router.navigate(['creditorhome']);
    }
    else {
      this.router.navigate(['/']);
    }
  }
}
